import PageActions from './PageActions.js';

export default PageActions;
